export const authenticationState = {
    NOT_LOGGED_IN : 0,
    LOGGED_IN : 1,
    LOGGING_IN : 2,
    CREATING_ACCOUNT : 3,
    CREATED_ACCOUNT : 4
};